<template>
  <div class="sidemenu-item" @click="handleMenu">
    <div class="sidemenu-item-header">
      {{ name }}
      <img src="@/assets/icons/icon-chevron.svg" alt="chevron" />
    </div>
    <div class="sidemenu-item-body" :class="{ open: open }">
      <div class="sidemenu-item-menus">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSideMenuItem',
  props: {
    name: String,
  },
  data() {
    return {
      open: false,
    };
  },

  mounted() {},

  methods: {
    handleMenu() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidemenu-item {
  border-bottom: 1px solid #ddd;
  width: 100%;
  .sidemenu-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .sidemenu-item-body {
    display: grid;
    grid-template-rows: 0;
    &.open {
      grid-template-rows: 1fr;
    }
    .sidemenu-item-menus {
      display: flex;
      flex-direction: column;
      /* gap: 30px; */
      /* margin-top: 10px; */
      /* margin-bottom: 28px; */
			/* padding-bottom: 10px; */
      overflow: hidden;
      a {
        color: black;
        font-size: 14px;
        font-weight: bold;
        padding: 17px 20px;
        &.disabled {
          color: #666;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
